import type { ScheduleRow, SeatOut } from '@conciair/scheduler-core';

/**
 * D13: Publish re-runs the engine on a fresh snapshot and must reproduce
 * the reviewed draft exactly. Rows are compared by window key on the
 * fields that define an assignment, independent of array order.
 */
function seatSig(s: SeatOut): string {
  return [s.pilotId ?? '', s.start, s.end, s.days, s.absorbed ? 1 : 0, s.pinned ? 1 : 0, s.double ? 1 : 0, s.supervised ? 1 : 0, s.actingTC ? 1 : 0].join(',');
}

export function scheduleSignature(rows: ScheduleRow[]): Map<string, string> {
  const m = new Map<string, string>();
  for (const r of rows) m.set(`${r.tail}|${r.rotationStart}`, `${r.rotationEnd}|${r.type}|${r.inserted ? 1 : 0}|${seatSig(r.pic)}|${seatSig(r.sic)}`);
  return m;
}

export interface ScheduleMismatch {
  key: string;
  kind: 'missing-in-fresh' | 'missing-in-draft' | 'different';
}

/** Empty when the two schedules are identical assignment for assignment. */
export function compareSchedules(draft: ScheduleRow[], fresh: ScheduleRow[]): ScheduleMismatch[] {
  const a = scheduleSignature(draft);
  const b = scheduleSignature(fresh);
  const out: ScheduleMismatch[] = [];
  for (const [k, sig] of a) {
    const other = b.get(k);
    if (other === undefined) out.push({ key: k, kind: 'missing-in-fresh' });
    else if (other !== sig) out.push({ key: k, kind: 'different' });
  }
  for (const k of b.keys()) if (!a.has(k)) out.push({ key: k, kind: 'missing-in-draft' });
  return out.sort((x, y) => x.key.localeCompare(y.key));
}

export function countGaps(rows: ScheduleRow[]): number {
  return rows.reduce((n, r) => n + (r.pic.pilotId || r.pic.absorbed ? 0 : 1) + (r.sic.pilotId || r.sic.absorbed ? 0 : 1), 0);
}
